export default __webpack_public_path__ + "static/media/cohort-video-placeholder-thumbnail.4edf8403.jpg";